<template>

  <div class="wrap">

    <div class="page-header">
      <Nav :activeId="activeId" />
    </div>

    <div class="page-banner" style="position: relative;">
      <img :src="require(`@/img/case/detail/banner/${id}.jpg`)" class="bg" />

      <!-- <div class="top-breadcrumb">
        <img src="../../img/case/global/nav-top.png" class="case" />
      </div> -->
      <div class="nav-bar">
        <!-- <div class="nav-bar_label">Explore Bänninger</div> -->
        <div class="nav-bar_label">Conex Bänninger Discovery</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>探索班尼戈</span><span>优秀案例</span>全球案例
        </div>
      </div>

      <div class="mask">
        <img src="../../img/news/mask-bg.png" />
        <div class="layer">
          <div class="layer-title">{{detail.title}}</div>
          <!-- <img src="../../img/news/btn-read.png" class="layer-btn"> -->
        </div>
      </div>
    </div>

    <div class="section-one self-bg">
      <div class="content-pic">
        <img :src="require(`@/img/case/detail/content/${id}.png`)" />
      </div>
    </div>

    <Footer />

  </div>

</template>

<script>
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 0,
      id: 1,
      detail: [],
      list: [
        {
          id: 1,
          title: 'Conex Compression Is The Versatile Choice To Connect Services In A Controversial Build'
        },
        {
          id: 2,
          title: '>B< Press sed for a quick and safe installation of water services at The Squaire, Frankfurt'
        },
        {
          id: 3,
          title: '>B< Press plays a key part in church restoration'
        },
        {
          id: 4,
          title: '>B< Press is a reliable choice for connecting water services in The Elbphilharmonie'
        },
        {
          id: 5,
          title: '>B< Press frees up space at prestigious Victorian Andaz Hotel, London'
        },
        {
          id: 6,
          title: '>B< Press keeps heating and chilled water services hygienic at Adelaide Hospital'
        },
        {
          id: 7,
          title: '>B< Press gets services going without delay at the new Hackesches Quartier'
        }
      ]
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    this.id = this.$route.params.id
    this.detail = this.list.find(item => item.id == this.id)
    console.log(this.id)
    console.log(this.detail)
  },
  methods: {}
};
</script>

<style scoped lang="less">
.page-banner {
  .bg {
    // max-height: 721px;
    // object-fit: fill;
  }
}
.self-bg {
  min-height: 500px;
  // padding: 30px 0;
  background-color: #EFEFEF;
  overflow: auto;
  padding: 100px 0 200px;
}
.sub-title {
  width: 1100px;
  margin: 0 auto 50px;
  img {
    width: 100%;
    height: auto;
  }
}
.content-pic {
  width: 1100px;
  height: auto;
  margin: 0 auto;
  img {
    width: 100%;
    height: auto;
  }
}
.mask {
  width: 100%;
  position: absolute;
  bottom: 0;
  .layer {
    width: 1100px;
    position: absolute;
    margin: 0 auto;
    // top: 50%;
    // padding: 0 50px;
    left: 0;
    right: 0;
    bottom: 30px;
    color: #FFF;
    text-align: left;
    .layer-title {
      font-size: 24px;
      // font-weight: bold;
      margin-bottom: 10px;
    }
    .layer-btn {
      width: 139px;
      height: 29px;
    }
  }
}
</style>